import { useRefinedFacets } from './useRefinedFacets';

export const useNbRefinedFacets = (): number => useRefinedFacets().length;
